/** Wartezeiten: Sekunden <-> Tage/Stunden/Minuten (Wartezeit-Knoten des Flow-Builders und Schritt 6 des Wizards). */

export function splitTimeInSeconds(seconds: number) {
  const days = Math.floor(seconds / (24 * 3600));
  seconds %= 24 * 3600;
  const hours = Math.floor(seconds / 3600);
  seconds %= 3600;
  const minutes = Math.floor(seconds / 60);

  return { days, hours, minutes };
}

export function convertToSeconds(timeObj: { days: number; hours: number; minutes: number }) {
  const { days, hours, minutes } = timeObj;
  const totalSeconds = days * 24 * 3600 + hours * 3600 + minutes * 60;
  return totalSeconds;
}
